// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme-text-color: #1a1d4f;
}

.sidebar {
  left: 500px;
}`, "",{"version":3,"sources":["webpack://./src/wrapper/index.scss"],"names":[],"mappings":"AAEA;EACE,2BAAA;AADF;;AAGA;EACE,WAAA;AAAF","sourcesContent":["@use \"./../assets/variables\" as *;\n\n:root {\n  --theme-text-color: #{$themeColor};\n}\n.sidebar {\n  left: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
